










import { Component, Vue } from "vue-property-decorator";
import OfferForm from "@/components/sale/forms/OfferForm.vue";

@Component({
  components: { OfferForm },
})
export default class extends Vue {}
